// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AnchorScrollController from "./anchor_scroll_controller";
application.register("anchor-scroll", AnchorScrollController);

import CreditCardInputController from "./credit_card_input_controller";
application.register("credit-card-input", CreditCardInputController);

import DropdownOtherController from "./dropdown_other_controller";
application.register("dropdown-other", DropdownOtherController);

import FileUploadController from "./file_upload_controller";
application.register("file-upload", FileUploadController);

import ImageCropController from "./image_crop_controller";
application.register("image-crop", ImageCropController);

import FormReloadController from "./form_reload_controller";
application.register("form-reload", FormReloadController);

import InputMaskController from "./input_mask_controller";
application.register("input-mask", InputMaskController);

import MultifileDownloadController from "./multifile_download_controller";
application.register("multifile-download", MultifileDownloadController);

import PageLoadController from "./page_load_controller";
application.register("page-load", PageLoadController);

import PerPageController from "./per_page_controller";
application.register("per-page", PerPageController);

import PlacesController from "./places_controller";
application.register("places", PlacesController);

import PopperController from "./popper_controller";
application.register("popper", PopperController);

import ProductVariantsController from "./product_variants_controller";
application.register("product-variants", ProductVariantsController);

import Questions__Base__Question1BaseController from "./questions/base/question1_base_controller";
application.register(
  "questions--base--question1-base",
  Questions__Base__Question1BaseController
);

import Questions__Base__Question2BaseController from "./questions/base/question2_base_controller";
application.register(
  "questions--base--question2-base",
  Questions__Base__Question2BaseController
);

import Questions__DesignedInQuebec__Question1Controller from "./questions/designed_in_quebec/question1_controller";
application.register(
  "questions--designed-in-quebec--question1",
  Questions__DesignedInQuebec__Question1Controller
);

import Questions__DesignedInQuebec__Question2Controller from "./questions/designed_in_quebec/question2_controller";
application.register(
  "questions--designed-in-quebec--question2",
  Questions__DesignedInQuebec__Question2Controller
);

import Questions__DesignedInQuebec__Question3Controller from "./questions/designed_in_quebec/question3_controller";
application.register(
  "questions--designed-in-quebec--question3",
  Questions__DesignedInQuebec__Question3Controller
);

import Questions__MadeInQuebec__Question1Controller from "./questions/made_in_quebec/question1_controller";
application.register(
  "questions--made-in-quebec--question1",
  Questions__MadeInQuebec__Question1Controller
);

import Questions__MadeInQuebec__Question2Controller from "./questions/made_in_quebec/question2_controller";
application.register(
  "questions--made-in-quebec--question2",
  Questions__MadeInQuebec__Question2Controller
);

import Questions__ProducedInQuebec__Question1Controller from "./questions/produced_in_quebec/question1_controller";
application.register(
  "questions--produced-in-quebec--question1",
  Questions__ProducedInQuebec__Question1Controller
);

import Questions__ProducedInQuebec__Question2Controller from "./questions/produced_in_quebec/question2_controller";
application.register(
  "questions--produced-in-quebec--question2",
  Questions__ProducedInQuebec__Question2Controller
);

import RenewalProductCompleteController from "./renewal_product_complete_controller";
application.register(
  "renewal-product-complete",
  RenewalProductCompleteController
);

import RenewalProductConfirmationController from "./renewal_product_confirmation_controller";
application.register(
  "renewal-product-confirmation",
  RenewalProductConfirmationController
);

import SortableController from "./sortable_controller";
application.register("sortable", SortableController);

import TinymceController from "./tinymce_controller";
application.register("tinymce", TinymceController);

import TomSelectController from "./tom_select_controller";
application.register("tom-select", TomSelectController);

import FormSubmitController from "./form_submit_controller";
application.register("form-submit", FormSubmitController);

import AutoCompleteController from "./auto_complete_controller";
application.register("auto-complete", AutoCompleteController);

import HomeV2Controller from "./home_v2_controller";
application.register("home-v2", HomeV2Controller);

import V2VideoController from "./v2_video_controller";
application.register("v2-video", V2VideoController);

import ContactCopyController from "./contact_copy_controller";
application.register("contact-copy", ContactCopyController);

import PromotionalCodeController from "./promotional_code_controller";
application.register("promotional-code", PromotionalCodeController);

import PromotionalCodeFieldsController from "./promotional_code_fields_controller";
application.register("promotional-code-fields", PromotionalCodeFieldsController);

import ModalAlertController from "./modal_alert_controller";
application.register("modal-alert", ModalAlertController);
